import tinymce from "tinymce"
tinymce.PluginManager.add("dynamicTable", function(editor, url) {
  let pluginName = "动态表格"
  var openDialog = function() {
    return editor.fire("dynamicTable")
  }

  editor.ui.registry.getAll().icons["dynamic-table"] ||
    editor.ui.registry.addIcon(
      "dynamic-table",
      '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M928,64H96C43,64,0,107,0,160V864c0,53,43,96,96,96H928c53,0,96-43,96-96V160c0-53-43-96-96-96zM448,832H128V640H448V832zm0-320H128V320H448V512zM896,832H576V640H896V832zm0-320H576V320H896V512z"/></svg>'
    )

  // 注册一个工具栏按钮名称
  editor.ui.registry.addButton("dynamicTable", {
    icon: "dynamic-table",
    tooltip: pluginName,
    onAction: function() {
      openDialog()
    }
  })

  // 注册一个菜单项名称 menu/menubar
  editor.ui.registry.addMenuItem("dynamicTable", {
    text: "动态表格",
    icon: "dynamic-table",
    onAction: function() {
      openDialog()
    }
  })

  return {
    getMetadata: function() {
      return {
        // 插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
        name: "dynamicTable", // 插件名称
        url: "" // 作者网址
      }
    }
  }
})
